'use strict';

import axios from 'axios';
import qs from 'qs';

axios.interceptors.request.use(
  config => {
    // loading
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.resolve(error.response);
  }
);

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    return response.data;
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: '网络异常'
  };
}

function checkCode(res) {
  return res;
}

export default {
  post(url, data, type) {
    let ContentType = 'application/x-www-form-urlencoded;charset=UTF-8';
    let postData = "";
    if (type === "JSON"){
      ContentType = 'application/json';
      postData = data;
    } else {
      postData = qs.stringify(data);
    }
    return axios({
      method: 'post',
      url,
      data:postData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type':  ContentType
      }
    })
      .then(response => {
        return checkStatus(response);
      })
      .then(res => {
        return checkCode(res);
      });
  },
  get(url, data) {
    return axios.get(url, {params: data})
      .then(response => {
        return checkStatus(response);
      })
      .then(res => {
        return checkCode(res);
      });
  }
};



// WEBPACK FOOTER //
// ./src/api/http/http.js